import { combineReducers } from 'redux'
import { reducer as pdfLink } from './getPdfLink'

export default combineReducers({
    pdfLink,
})
